import { Controller } from '@hotwired/stimulus'

// Connects to data-controller="events"
export default class extends Controller {
  static targets = ['event', 'selection', 'selectionContainer', 'compare', 'selectedIds']
  static values = {
    selectedEventIds: { type: Array, default: [] }
  }

  connect () {
    this.clearSelectionOnPageHide = this.clearSelection.bind(this)
    window.addEventListener('pagehide', this.clearSelectionOnPageHide)
  }

  disconnect () {
    window.removeEventListener('pagehide', this.clearSelectionOnPageHide)
  }

  select (event) {
    const checkbox = event.currentTarget
    const id = checkbox.dataset.eventId

    if (checkbox.checked && this.selectedEventIdsValue.length < 6) {
      this.selectedEventIdsValue = [...this.selectedEventIdsValue, id]
    } else {
      checkbox.checked = false
      this.selectedEventIdsValue = this.selectedEventIdsValue.filter(selectedId => selectedId !== id)
    }
  }

  clearSelection () {
    this.eventTargets.forEach(row => {
      row.classList.remove('selected')
      const checkbox = row.querySelector("input[data-action='click->events#select']")
      if (checkbox) checkbox.checked = false
    })
    this.selectionTargets.forEach(input => input.closest('.event-selection')?.remove())
    if (this.hasCompareTarget) this.compareTarget.classList.add('disabled')
    this.selectedEventIdsValue = []
  }

  view (event) {
    if (event.target.closest('a, button, input, select, textarea, [role="button"], .event-compare-cell')) return

    window.location.assign(event.currentTarget.dataset.eventUrl)
  }

  selectedEventIdsValueChanged (value, previousValue) {
    if (!previousValue) return
    if (this.hasCompareTarget) this.compareTarget.classList.toggle('disabled', value.length < 2 || value.length > 6)
    if (value.length < previousValue.length) {
      const removedValues = previousValue.filter(id => !value.includes(id))
      this.selectionTargets.filter(target => removedValues.includes(target.getAttribute('value'))).forEach(ele => ele.closest('.event-selection').remove())
      this.eventTargets.filter(target => removedValues.includes(target.dataset.eventId)).forEach(ev => {
        ev.classList.remove('selected')
        const checkbox = ev.querySelector("input[data-action='click->events#select']")
        if (checkbox) checkbox.checked = false
      })
    } else if (value.length > previousValue.length) {
      const selectedIds = this.hasSelectedIdsTarget ? this.selectedIdsTargets.map(ele => ele.dataset.id) : []
      const addedValues = value.filter(ele => !previousValue.includes(ele) && !selectedIds.includes(ele))
      const tags = (addedValues.map(id => this._getEventSelection(id))).join('')
      if (this.hasSelectionContainerTarget) this.selectionContainerTarget.innerHTML += tags
      this.element.querySelectorAll('[action*="/events"]:not(.event-selection-container)').forEach(form => {
        form.innerHTML += tags
      })
      this.eventTargets.filter(target => addedValues.includes(target.dataset.eventId)).forEach(ele => {
        ele.classList.add('selected')
        const checkbox = ele.querySelector("input[data-action='click->events#select']")
        if (checkbox) checkbox.checked = true
      })
    }
    this.updateLinks()
  }

  updateLinks () {
    this.element.querySelectorAll('.main [href*="/events"]').forEach(link => {
      const url = new URL(link.href, window.location.origin)
      url.searchParams.delete('events[]')
      this.selectedEventIdsValue.forEach(v => url.searchParams.append('events[]', v))
      link.href = url.toString()
    })
  }

  remove (event) {
    const id = event.currentTarget.dataset.id
    this.selectedEventIdsValue = this.selectedEventIdsValue.filter(val => val !== id)
  }

  _getEventSelection = (id) =>
    `<div class="event-selection" data-events-target="selectedIds" data-action="click->events#remove" data-id="${id}">
      <div class="id">${id}</div>
      <div class="hidden">${this._getHiddenField(id)}</div>
    </div>`

  _getHiddenField = (id) => `<input type="hidden" name="events[]" value="${id}" data-events-target="selection">`
}
